import { defineNuxtPlugin, useRuntimeConfig } from "nuxt/app";
import type { BroadcastingService } from "../types";
import { NoopService } from "../service/noop-service";
import { ClientService } from "../service/client-service";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  let service: BroadcastingService;

  if (!config.public.broadcasting.enabled || import.meta.server) {
    service = new NoopService();
  } else {
    service = new ClientService(
      config.public.broadcasting.providerKey,
      config.public.broadcasting.providerCluster,
    );
  }

  return {
    provide: {
      broadcasting: service,
    },
  };
});
